import type { PoolOfferConfig } from '../../lib/api/operatorConsole';

/** Where Save writes: the template's global animation, or one pack's own opening. */
export type AnimationScope = 'global' | 'pack';

/** A backend without per-pack openings drops the key and still answers 200. */
export const PACK_OPENING_UNSUPPORTED = 'Per-pack openings are not available on the server yet';

/** The real pack behind a selector value; the empty prompt and the lab demo have none. */
export function findPack(packs: PoolOfferConfig[], packId: string): PoolOfferConfig | undefined {
  return packs.find((p) => String(p.pool_offer_id) === packId);
}

export function packTitle(pack: PoolOfferConfig): string {
  return pack.title ?? pack.pool_offer_title;
}

/** Why the selected pack cannot get its own opening; null when it can. */
export function packScopeBlocker(
  canWritePacks: boolean,
  pack: PoolOfferConfig | undefined,
): string | null {
  // Pack openings are written through pool_offer_configs, which needs the offers section
  if (!canWritePacks) return 'Needs access to Configs';
  return pack ? null : 'Select a pack to give it its own opening';
}
